import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permission.service';

@Component({
  selector: 'app-milestone-master',
  standalone:false,
  templateUrl: './milestone-master.component.html',
  styleUrl: './milestone-master.component.scss'
})
export class MilestoneMasterComponent implements OnInit, OnDestroy {
  title = 'Milestone Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  systemForm: FormGroup;
  private subscriptions = new Subscription();
  system: any[]
  // isCardView: boolean = true;
  cols: any[] = [
    { field: 'name', header: ' Name', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'description', header: 'Description', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px' },

  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false

  constructor(private fb: FormBuilder, private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // this.getSystem();
    this.systemForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      description: ['', Validators.required],
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/class-master/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      let resp = res.data || res.results
      this.totalRecords = res.count || 0
      this.system = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      }));
    });
    this.subscriptions.add(sub);
  }


  addSystem() {
    this.systemForm.reset();
    this.systemForm.enable()
    this.showDialog = true;

  }
  onSubmitadd() {
    if (this.systemForm.valid) {
      let payload = {
        name: this.systemForm.get('name')?.value,
        description: this.systemForm.get('description')?.value,
      }
      const sub = this.api.postAPI('/master/class-master/', payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Milestone submitted successfully'
          });
          this.showDialog = false;
          this.systemForm.reset();
          this.getSystem();


        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'failed',
            detail: res.name
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }
viewMode = false;
viewSystem(rowData: any) {
  this.viewMode = true;
   if (rowData && rowData.id) {
      this.selectedsystem = rowData;
      this.isUpdatedialog = true
      this.systemForm.patchValue({
        name: rowData.name || '',
        description: rowData.description || '',
      });
      this.systemForm.disable()
    }
}
  updateSystem(equipment: any): void {
    this.viewMode= false;
    this.systemForm.enable()
    this.isUpdatedialog = true
    this.selectedsystem = equipment; // Store selected equipment
    this.systemForm.patchValue({
      name: equipment.name,
      description: equipment.description,
    })
  }


  // Submit button handler

  onSubmitEq() {
    let sectionId = this.selectedsystem.id
    let payload = {
      name: this.systemForm.get('name')?.value,
      description: this.systemForm.get('description')?.value,
    }
    const sub = this.api.putAPI(`/master/class-master/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Milestone updated successfully'
        });
        this.isUpdatedialog = false;
        this.systemForm.reset();
        this.getSystem()
      } else {
        this.messageService.add({
          severity: 'failed',
          summary: 'Failed',
          detail: res.detail
        });
      }
    });
    this.subscriptions.add(sub);
    this.isUpdatedialog = false; // Close the popup
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    // this.selectedsystem = equipment;
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/class-master/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Milestone Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/class', 'Edit') ||
      this.permissionService.hasPrivilege('/master/class', 'Delete')||
      this.permissionService.hasPrivilege('/master/class', 'View');
  }
}
